import { useState } from 'react';
import { Modal, Button } from '../ui';
import InsightForm, { InsightFormState, emptyInsightForm } from '../ui/InsightForm';
import { NewInsightPayload } from 'types';

type AddInsightModalProps = {
    onConfirm: (payload: NewInsightPayload) => void;
    onClose: () => void;
    onDelete?: () => void;
    initialValues?: InsightFormState;
    existingUsers?: string[];
};

export default function AddInsightModal({ onConfirm, onClose, onDelete, initialValues, existingUsers }: AddInsightModalProps) {
    const [form, setForm] = useState<InsightFormState>(initialValues ?? emptyInsightForm());
    const isEdit = !!initialValues;

    const handleChange = (key: keyof InsightFormState, value: string) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    const isValid = !!(form.title.trim() && form.sourceUserName.trim() && form.description.trim());

    const submit = () => {
        if (!isValid) return;
        const payload: NewInsightPayload = {
            title: form.title.trim(),
            description: form.description.trim(),
            sourceUser: {
                name: form.sourceUserName.trim(),
                identifier: form.sourceUserIdentifier.trim() || undefined,
                identifierType: form.sourceUserIdentifier.trim() ? form.sourceUserIdentifierType : undefined,
            },
            sourceUrl: form.sourceUrl.trim() || undefined,
            cornerColor: form.cornerColor || undefined,
        };
        onConfirm(payload);
    };

    return (
        <Modal title={isEdit ? 'Edit Insight' : 'New Insight'} onClose={onClose} closeOnOverlayClick>
            <div className='insight-add-form'>
                <InsightForm value={form} onChange={handleChange} autoFocus={!isEdit} existingUsers={existingUsers} />
            </div>
            <div className='modal-actions'>
                {isEdit && onDelete && (
                    <Button variant='danger' onClick={onDelete} style={{ marginRight: 'auto' }}>Delete</Button>
                )}
                <Button variant='secondary' onClick={onClose}>Cancel</Button>
                <Button variant='primary' onClick={submit} disabled={!isValid}>
                    {isEdit ? 'Save Changes' : 'Add Insight'}
                </Button>
            </div>
        </Modal>
    );
}
